import { render, staticRenderFns } from "./CompareVertical.vue?vue&type=template&id=6af3c34f&"
import script from "./CompareVertical.vue?vue&type=script&lang=js&"
export * from "./CompareVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports